// see order/README sl errors
const WARNING_TYPES = ['allocation_missing', 'non_allocated']
// listOrdersForUser is used in the app internally
// while list is used in the REST api externally
exports.allocationTypeIsWarning = allocationTypeIsWarning
function allocationTypeIsWarning (allocationType) {
  if (!allocationType) return true
  return WARNING_TYPES.includes(allocationType)
}
